// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-7d181f7c]{bottom:20px}.main-body[data-v-7d181f7c]{min-height:600px}.signature[data-v-7d181f7c]{border:1px solid;border-radius:4px}h1[data-v-7d181f7c]{font-size:18px}h2[data-v-7d181f7c]{font-size:14px}h3[data-v-7d181f7c]{font-size:12px}.pdf[data-v-7d181f7c]{font-size:10px;width:595px;background-color:#fff;margin:0 auto;padding:12px}.bordered[data-v-7d181f7c]{border-top:1px solid;border-bottom:1px solid}", ""]);
// Exports
module.exports = exports;
